const AllReleases = () => {
  return (
    <>
      <div className="container p-5 border shadow rounded-5 my-3">
        <h2 className="mb-3 fw-bold about-us-yatra-title">
          BHAGVA TRISHOOL YATRA PRESS RELEASES:
        </h2>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          13th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-2 text-release-links">
          <a
            href="/bhagva-trishool-yatra/13032025/sisaye"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा हरियाणा के{" "}
            <span className="fw-bold">सबसे बड़े गांव सिसाय</span> पहुंची, हजारों
            ग्रामीणों ने किया भव्य स्वागत
          </a>
        </div>
        <div className="col-md-12 text-orange fw-bold text-release-links text-start">
          13th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-2 text-release-links">
          <a
            href="/bhagva-trishool-yatra/13032025/mahipalpur"
            className="text-black"
          >
            <span className="fw-bold">महिपालपुर शिव मंदिर</span> पहुंची भगवा
            त्रिशूल यात्रा, महामंडलेश्वर निरंजनी अखाड़ा आचार्य कैलाशानंद जी
            महाराज ने दिया आशीर्वाद
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          12th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-2 text-release-links">
          <a href="/bhagva-trishool-yatra/12032025/jind" className="text-black">
            भगवा त्रिशूल यात्रा, <span className="fw-bold">जींद</span> बाबा
            रामसर तीर्थ पहुंची, नैन खाप के प्रमुखों की गरिमामयी उपस्थिति में हुआ
            भव्य स्वागत
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          12th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-2 text-release-links">
          <a
            href="/bhagva-trishool-yatra/12032025/hisar"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">हिसार</span> पहुंची,
            श्रद्धालुओं ने भव्य स्वागत कर किया धर्म जागरण का आह्वान
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          8th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-2 text-release-links">
          <a
            href="/bhagva-trishool-yatra/08032025/haridwar"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">हरिद्वार</span>: गंगा
            के सरवानंद घाट पर विशेष पूजन और 120 पवित्र त्रिशूलों का अभिषेक
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          7th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-2 text-release-links">
          <a
            href="/bhagva-trishool-yatra/07032025/haridwar"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">हरिद्वार</span>: बनी
            सामाजिक एकता और आध्यात्मिक पुनर्जागरण की मिसाल
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          7th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/07032025/meerut"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">मेरठ :</span>
            अंतर्राष्ट्रीय मंदिर प्रबंधक परिषद (IMPC) द्वारा आयोजित भगवा त्रिशूल
            यात्रा का मेरठ में भव्य स्वागत किया गया।
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          7th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/07032025/haridwar"
            className="text-black"
          >
            7 मार्च को पूजनीय आचार्य श्री कैलाशानंद गिरी जी महाराज के आश्रम
            हरिद्वार पहुंचेगी 108 भगवा त्रिशूल यात्रा
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          6th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/06032025/badayuAurSambal"
            className="text-black"
          >
            अंतर्राष्ट्रीय मंदिर प्रबंधक परिषद (IMPC) और भगवा ऐप के संयुक्त
            तत्वावधान में आयोजित भगवा त्रिशूल यात्रा 2025 आज उत्तर प्रदेश के
            बदायूं और संभल पहुंच चुकी है।
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          5th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/05032025/badayu-sambhal"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा:{" "}
            <span className="fw-bold">बदायूं और संभल :</span>
            में ऐतिहासिक स्वागत, हजारों कार्यकर्ता होंगे शामिल
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          5th Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/05032025/sambhal"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा: <span className="fw-bold">संभल :</span>
            अंतर्राष्ट्रीय मंदिर प्रबंधक परिषद और भगवा ऐप के संयुक्त तत्वावधान
            में आयोजित भगवा त्रिशूल यात्रा 2025 उत्तर प्रदेश के विभिन्न धार्मिक
            स्थलों से होती हुई 6 मार्च को संभल पहुंचेगी।
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          3rd Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/03032025/ayodhya"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा: <span className="fw-bold">अयोध्या :</span>
            सनातन संस्कृति के उत्थान और मंदिरों के आधुनिकीकरण के संकल्प के साथ
            निकली अंतर्राष्ट्रीय मंदिर प्रबंधक परिषद (IMPC) एवं भगवा ऐप की भगवा
            त्रिशूल यात्रा आज प्रभु श्रीराम की नगरी अयोध्या पहुंची।
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          2nd Mar, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/02032025/prayagraj"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">प्रयागराज :</span>
            श्रद्धा, शक्ति और सनातन संस्कृति का अद्भुत संगम!
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          27th Feb, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/27022025/delhi"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">दिल्ली :</span>
            प्रयागराज से दिल्ली तक, सनातन धर्म के गौरव की पुनर्स्थापना की
            ऐतिहासिक पहल
          </a>
        </div>
        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          24nd Feb, 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/bhagva-trishool-yatra/24022025/delhi"
            className="text-black"
          >
            भगवा त्रिशूल यात्रा, <span className="fw-bold">दिल्ली :</span>
            सनातन संस्कृति के उत्थान और प्राचीन शिवालयों के पुनरुद्धार के संकल्प
            के साथ, अंतर्राष्ट्रीय मंदिर प्रबंधक परिषद (IMPC) एवं भगबा ऐप द्वारा
            "भगवा त्रिशूल यात्रा" का भव्य शुभारंभ होने जा रहा है।
          </a>
        </div>

        <h2 className="mt-5 mb-3 fw-bold about-us-yatra-title">
          MAHASANGAM PRESS RELEASES:
        </h2>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 15th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/15022025/ujjain"
            className="text-black"
          >
            15 फरवरी को उज्जैन पहुंचेगी महासंगम यात्रा, महाकालेश्वर ज्योतिर्लिंग
            क े दर्शन करेंगे श्रद्धालु भगवान शिव क े साकार, स्वयंभू और अखंड
            दिव्य स्वरूप का प्रतीक है महाकाल मंदिर{" - "}
            <span className="fw-bold">उज्जैन, मध्य प्रदेश</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 12th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/12022025/somnath-temple"
            className="text-black"
          >
            गुजरात क े सोमनाथ मंदिर पहुंची महासंगम यात्रा, भारतीय संस्कति और
            प्राचीन धरोहरों डिजिटल संगम
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 12th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/12022025/surat"
            className="text-black"
          >
            सूरत पहुंची महासंगम यात्रा, सूर्यपुत्री तापी माता और नर्मदेश्वर
            महादेव क े पावन दर्शन {" - "}
            <span className="fw-bold">सूरत</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 10th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/10022025/delhi"
            className="text-black"
          >
            सनातन संस्कति की पुनर्प्रतिष्ठा का संकल्प लिए 12 फरवरी को सोमनाथ
            पहुँचेगी महासंगम यात्रा {" - "}
            <span className="fw-bold">सोमनाथ/दिल्ली</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 10th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/10022025/delhi"
            className="text-black"
          >
            Mahasangam Yatra: A Historic Initiative to Connect India’s Ancient
            Temples and Priests with the Digital Era{" - "}{" "}
            <span className="fw-bold">New Delhi</span>.
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 10th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/10022025/nasik"
            className="text-black"
          >
            सनातन संस्क ृति की पुनर्प्रतिष्ठा का संकल्प लिए 10 फरवरी को नासिक
            पहुचेगी महासंगम यात्रा
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 8th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/08022025/maharashtra"
            className="text-black"
          >
            अंतरराष्ट्रीय मंदिर प्रबंधक परिषद क े कार्यकारी अध्यक्ष राजेश यादव
            जी महासंगम यात्रा से जुड़े, भीमाशंकर मंदिर में किए दर्शन{" - "}
            <span className="fw-bold">भीमाशंकर/महाराष्ट्र</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 5th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/05022025/ranchi"
            className="text-black"
          >
            7 फरवरी को कर्नाटक के हम्पी पहुंचेगी महासंगम यात्रा, जहां होगा धर्म,
            संस्कृति और डिजिटल पहल का संगम
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 5th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/05022025/rameswaram"
            className="text-black"
          >
            Mahasangam Yatra: An Initiative to Preserve India’s Cultural
            Heritage and Connect Youth with Values{" - "}
            <span className="fw-bold">Rameswaram, Tamil Nadu</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 5th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/05022025/coimbatore"
            className="text-black"
          >
            Mahasangam Yatra Reaches Isha Foundation:Coimbatore.
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 3rd 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/03022025/andhrapradesh"
            className="text-black"
          >
            IMPC की महासंगम यात्रा ने किये मल्लिकार्जुन ज्योतिर्लिंग में दर्शन
            आन्द्रा क े श्रीशैल पर्वत सहित धार्मिक स्थलों क े दर्शन कर रहें भक्त
            {" - "} <span className="fw-bold">वेल्लोर, आंध्र प्रदेश</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Feb 1st 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/01022025/andhrapradesh"
            className="text-black"
          >
            IMPC’s Mahasangam Yatra Visits Mallikarjun Jyotirlinga.Mahasangam
            Yatra Reaches Krishna Nagar via Amravati, Andhra Pradesh; Grand
            Rudrabhishek and Trishul Puja Conducted{" - "}
            <span className="fw-bold">Andhra Pradesh</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Jan 30th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/30012025/bhubaneshwar"
            className="text-black"
          >
            IMPC's Mahasangam Yatra Reaches Lingaraj Temple, Bhubaneswar – Grand
            Rudrabhishek and Trishul Poojan Concluded{" - "}
            <span className="fw-bold">Bhubaneswar, Odisha</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Jan 29th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/29012025/puri"
            className="text-black"
          >
            IMPC’s Grand Sangam Yatra Reaches Shri Jagannath Puri Temple – One
            of the Four Sacred Dhams of Hinduism{" - "}
            <span className="fw-bold"> Puri, Odisha</span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Jan 24th 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/24012025/pyragraj"
            className="text-black"
          >
            24 जनवरी 2025 को प्रयागराज से होगा अंतर्राष्ट्रीय मंदिर प्रबंधक
            परिषद (IMPC) की पवित्र महासंगम यात्रा का शुभारंभ
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Jan 23rd 2025
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/23012025/delhi"
            className="text-black"
          >
            International MandirnPrbandhak Council(IMPC) Sacred Mahasangam
            Yatra: A Religious Grand Campaign for Jyotirlinga Darshan at Every
            Home, Delhi
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          आगरा, उत्तर प्रदेश
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a href="/mahasangam-press-release/-/agra" className="text-black">
            महासंगम यात्रा का आगरा में हुआ भव्य स्वागत, राहुल महाजन क े निवास पर
            रुद्राभिषेक{" - "}{" "}
            <span className="fw-bold">आगरा, उत्तर प्रदेश </span>
          </a>
        </div>

        <div className="col-md-12 text-start text-orange fw-bold text-release-links">
          Dwarka Gujrat
        </div>
        <div className="col-md-12 text-start py-1 text-release-links">
          <a
            href="/mahasangam-press-release/-/gujrat-dwarka"
            className="text-black"
          >
            द्वारका पहुंची महासंगम यात्रा, मां गोमती क े तट पर हुआ भव्य अनुष्ठान
            {" - "}
            <span className="fw-bold">द्वारका, गुजरात</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default AllReleases;
